import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { cloneDeep } from 'lodash';
import extendedDayJs from '@libs/utils/dayjs';
import { AbilityContext } from '@libs/@core/contexts/caslContext';
import BaseTableAction from '@libs/@core/components/table/BaseTableAction';
import { DuplicateIcon, EditIcon, EyeIcon, PulishIcon } from '@import/icons';
import { Actions, SUBJECTS } from '@libs/@core/security/rolePermissions';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
import { CashflowTemplateStatus } from '@modules/cashflow/cf-template/models/data';
import StatusChipTemplate from '@modules/cashflow/cf-template/component/status';
var useGetColumnTable = function () {
    var t = useCustomTranslation();
    var ability = useContext(AbilityContext);
    var viewFO = ability.can(Actions.MANAGE, SUBJECTS.OVERVIEW);
    var viewFD = ability.cannot(Actions.MANAGE, SUBJECTS.OVERVIEW);
    var columns = useMemo(function () { return [
        { id: 'templateNo', key: 'id', label: t('L000028') },
        { id: 'templateName', key: 'name', label: t('L000027') },
        {
            id: 'createdDate',
            key: 'createdAt',
            label: t('L000121'),
            render: function (data) { return extendedDayJs(data.createdAt).format('DD/MM/YYYY'); }
        },
        { id: 'status', key: 'status', label: t('L000004'), render: function (data) { return _jsx(StatusChipTemplate, { status: data.status }); } },
        {
            id: 'action',
            label: t('L000016'),
            render: function (data, actions) {
                var listItems = [
                    { key: 'detail', label: t('L000115'), icon: _jsx(EyeIcon, {}), type: 'detail' },
                    { key: 'update', label: t('L000117'), icon: _jsx(EditIcon, {}), type: 'edit' },
                    { key: 'publish-template', label: t('L000116'), icon: _jsx(PulishIcon, {}), type: 'publish' },
                    { key: 'duplicate', label: t('L000118'), icon: _jsx(DuplicateIcon, {}), type: 'duplicate' }
                ];
                var _list = cloneDeep(listItems);
                if (data.status === CashflowTemplateStatus.Published) {
                    _list = [_list[0]];
                }
                if (data.status === CashflowTemplateStatus.Unpublished) {
                    _list = _list.filter(function (item) { return item.key !== 'update'; });
                }
                return _jsx(BaseTableAction, { data: data, actions: actions, listItems: _list });
            }
        }
    ]; }, [viewFD, viewFO, t]);
    return columns;
};
export default useGetColumnTable;
